import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { GardenBedListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/garden-bed-list.response';
import { GardenBedType } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/garden-bed-type.enum';

interface BedCell {
  occupied: boolean;
}

/** Ligne « planche » compacte dans Mon Potager : mini-aperçu de la grille + nom + résumé. */
@Component({
  selector: 'vw-bed-item',
  imports: [SharedModule, CommonModule, TranslateModule],
  templateUrl: './bed-item.component.html',
  styleUrl: './bed-item.component.scss',
})
export class BedItemComponent {
  readonly GardenBedType = GardenBedType;

  @Input() bed!: GardenBedListResponse;
  /** Cultures « riches » (image + nom court) déjà résolues par le parent. */
  @Input() cultures: any[] = [];
  @Input() count = 0;
  @Input() freeCells = 0;

  /** Plafond de cases rendues dans le mini-aperçu (garde un petit « logo »). */
  private readonly MAX_CELLS = 24;

  get dimensionLabel(): string {
    if (this.bed.type === GardenBedType.POT) {
      return 'Pot';
    }
    return `${this.bed.rows ?? '-'} × ${this.bed.columns ?? '-'}`;
  }

  /** Nombre de colonnes du mini-aperçu. */
  get cols(): number {
    if (this.bed.type === GardenBedType.POT) {
      return Math.min(this.bed.capacity || 1, 4);
    }
    return this.bed.columns || 1;
  }

  /** Largeur (px) du mini-aperçu, bornée pour rester un petit logo. */
  get gridWidthPx(): number {
    return Math.min(56, Math.max(28, this.cols * 14));
  }

  /** Cases du mini-aperçu : occupées d'abord, puis vides (pointillés), plafonné. */
  get cells(): BedCell[] {
    const total =
      this.bed.type === GardenBedType.POT
        ? this.bed.capacity || 0
        : (this.bed.rows || 0) * (this.bed.columns || 0);
    const capped = Math.min(total || this.count, this.MAX_CELLS);
    const occupied = Math.min(this.count, capped);
    const out: BedCell[] = [];
    for (let i = 0; i < capped; i++) {
      out.push({ occupied: i < occupied });
    }
    return out;
  }
}
